module.exports = __webpack_public_path__ + "media/images/icon_income-f3746e417c85a7b3b3f3d4525906d813.svg";